import { useEffect, useState } from 'react';
import { onAuthStateChanged, signInAnonymously, User } from 'firebase/auth';
import { auth } from '../../firebase/config';

export function useAuth() {
  const [user, setUser] = useState<User | null>(null);
  const [uid, setUid] = useState<string | null>(null);

  useEffect(() => {
    let unsubscribe: (() => void) | undefined;

    const initializeAuth = async () => {
      try {
        // Sign in anonymously first
        await signInAnonymously(auth);
        // Set up auth state listener
        unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
          if (firebaseUser) {
            setUser(firebaseUser);
            setUid(firebaseUser.uid);
          } else {
            setUser(null);
            setUid(null);
          }
        });
      } catch (error) {
        console.error('Error signing in anonymously:', error);
      }
    };

    initializeAuth();

    // Cleanup function - this is what React will call
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  return { user, uid };
}
